let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6JqaD")).then(() => parcelRequire('3yjsn'));